<script setup lang="ts">
const year = new Date().getFullYear()
</script>

<template>
  <footer class="px-6 md:px-12 pb-10">
    <div class="max-w-6xl mx-auto flex flex-col gap-6">
      <div class="border-fade w-full" />
      <div
        class="flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-stone-500 dark:text-stone-500">
        <span>&copy; {{ year }} Nathalie Gottvalles. Tous droits réservés.</span>
        <div class="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs">
          <span>Psychologue — n° ADELI&nbsp;: 339 327 504 — n° RPPS&nbsp;: 1000 873 2611</span>
          <span class="hidden md:inline text-stone-400 dark:text-stone-600">·</span>
          <span>Mentions légales</span>
          <span class="hidden md:inline text-stone-400 dark:text-stone-600">·</span>
          <span>Politique de confidentialité</span>
        </div>
      </div>
    </div>
  </footer>
</template>
